import type { FaireProductEntity } from "../../entity_types/product";

export const p_m2tpykvx8w: FaireProductEntity = {
  token: "p_m2tpykvx8w",
  type: "product",
  name: "Rhinestone Cherry Keychain Bag Charm",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/dd8c3d27525742f0a8943db2e110ed86e807b566380db4ed84c9d5dc46381d50.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d5937126fdf90f90388824c1ece98cd4e7dd1bda8b3377ed15eddfc42a43923.jpeg",
    "https://cdn.faire.com/fastly/cc302e354b870450d449edf14c65c0a068539cc72b47d0aedd07ddf8be968c65.jpeg",
    "https://cdn.faire.com/fastly/93d0d7617fa339721b0e6d0354301a0e8221ae32bd0b3e901b31e745c19296e9.jpeg",
    "https://cdn.faire.com/fastly/747d9adbbd80f734592a9d8c9cd7e31f061e304ec71e3431ac02aceae6582e7b.jpeg",
    "https://cdn.faire.com/fastly/02f65055abd82d13bbcc4032886b213fe25950622ed273cb5dc6786e22db8292.jpeg",
    "https://cdn.faire.com/fastly/8c321c19a9b37cb8116d1f1797e391cfa6ae46b1dae60a6a9b745d0cb6e94a54.jpeg",
  ],
  priceDollars: 6.36,
  description:
    "cherry size: 4.4*4.74cm\nThis sparkly Cherry  keychain bag charm features an elegant bow silhouette fully embellished with rhinestones for a glamorous, eye-catching look. It adds a playful yet stylish accent to handbags, backpacks, or keys.\n\nDesigned with a soft strap and sturdy keyring, this Cherry  charm is easy to attach and comfortable to carry. Available in multiple colors, it’s a perfect giftable accessory for boutiques, gift shops, and impulse-buy displays.",
  tags: [],
  msrpDollars: 12.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:58.953Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
